// extracted by mini-css-extract-plugin
module.exports = {"socials":"s_D","social":"s_bp","instagram":"s_bq","github":"s_br"};